import isEqual from 'lodash-es/isEqual';
import { useEffect } from 'react';
import { useMountEffect } from './useMountEffect';
import { usePrevious } from './usePrevious';

export const useEffectOnValueChange = <T>(value: T, callback: () => void, runOnMount = false) => {
  const prevValue = usePrevious(value);
  useEffect(() => {
    if (!isEqual(value, prevValue)) {
      callback();
    }
  });
  useMountEffect(() => {
    if (runOnMount) {
      callback();
    }
  });
};
